import { useState } from "react";

import { ModalComponent } from "../..";
import { useModalControl } from "../../../../customHooks/useModalControl";
import {
  formatToCurrency,
  getOffsetFromPage,
} from "../../../../helperFunctions";
import { useFetchPendingDepositApprovalsQuery } from "../../../../redux/features/approvals/approvals.api";
import {
  DepositsApprovalQuery,
  DepositsApprovalsResponse,
} from "../../../../redux/features/approvals/approvals.type";
import { SingleCooperative } from "../../../../redux/features/cooperative/cooperative.type";
import {
  SingleBulkDepositLog,
  SingleDepositLog,
} from "../../../../redux/features/deposits/deposits.type";
import { ManualPaymentMethodsMap } from "../../../../utils/constants";
import { TagCard } from "../../../cards/tagCard";
import { TableComponent } from "../../../table/table";
import { TimeText } from "../../../typography/timeText";
import { ImageViewModal } from "../imageViewModal";

export const BulkDepositsEntriesModal = ({
  isModalOpen,
  onModalClose,
  cooprativeDetails,
  bulkEntry,
}: {
  isModalOpen: boolean;
  onModalClose: () => void;
  cooprativeDetails: SingleCooperative;
  bulkEntry: SingleBulkDepositLog;
}) => {
  const [query, setQuery] = useState<DepositsApprovalQuery>({
    limit: 10,
    offset: 0,
    coop: cooprativeDetails.id,
    filelog: true,
    fileId: bulkEntry.id,
  });
  const [selectedEntry, setSelectedEntry] = useState<SingleDepositLog>();

  const { handleModalClose, handleModalOpen, modal, modalOpen } =
    useModalControl();

  const { data: enntries, isFetching: fetchingEntries } =
    useFetchPendingDepositApprovalsQuery(
      {
        ...query,
      },
      {
        refetchOnMountOrArgChange: true,
      }
    );

  return (
    <>
      <ModalComponent
        isModalOpen={isModalOpen}
        onModalClose={() => {
          onModalClose();
        }}
        title={`Deposit Bulk Upload Entries`}
        topTitle
        subTitle=""
        childrenClassName="flex flex-col gap-6"
        modalClassName="!min-h-[572px] !max-w-[1038px]"
        hasButtons={false}
      >
        <TableComponent
          className="w-full !min-w-max md:!min-w-full"
          isRowClickable={false}
          mobileCardView
          headers={[
            "Name",
            "Amount",
            "Payment Method",
            "Payment Date",
            "Payment Proof",
          ]}
          headerClassName="!bg-white"
          isLoading={fetchingEntries}
          isTableEmpty={[0, undefined].includes(
            (enntries as DepositsApprovalsResponse)?.data?.results?.length
          )}
          isPaginated={true}
          emptrySrc="/assets/images/empty_state_cooperatives.svg"
          emptyTitle="No Entries Found"
          totalCount={(enntries as DepositsApprovalsResponse)?.data?.count}
          itemsPerPage={query?.limit}
          onPageChange={(page) => {
            setQuery({
              ...query,
              offset: getOffsetFromPage(page, query.limit ?? 0),
            });
          }}
          rows={
            (enntries as DepositsApprovalsResponse)?.data?.results?.map(
              (entry, idx) => {
                return {
                  id: entry?.id,
                  items: [
                    <p className="min-w-fit whitespace-nowrap">
                      {entry?.MembershipDepositoryID?.MemberID?.User?.FirstName}{" "}
                      {entry?.MembershipDepositoryID?.MemberID?.User?.LastName}
                    </p>,
                    formatToCurrency(entry?.Amount, {
                      decimalPlaces: 2,
                      currency: "NGN",
                    }),
                    <TagCard
                      text={ManualPaymentMethodsMap[entry.paymentMode]}
                      type={"info"}
                    />,
                    <TimeText
                      timeString={entry.PaymentDate}
                      key={`entry-${entry.id}-date-${idx}`}
                    />,
                    <button
                      type="button"
                      className="text-pry-green-200 w-fit"
                      onClick={() => {
                        setSelectedEntry(entry);
                        handleModalOpen("imageViewModal");
                      }}
                      key={`entry-${entry.id}-proof-${idx}`}
                    >
                      View Proof
                    </button>,
                  ],
                };
              }
            ) ?? []
          }
        />
      </ModalComponent>

      {!!selectedEntry?.payslip ? (
        <ImageViewModal
          modalOpen={modalOpen && modal === "imageViewModal"}
          onModalClose={() => {
            handleModalClose();
            setSelectedEntry(undefined);
          }}
          src={selectedEntry?.payslip}
        />
      ) : undefined}
    </>
  );
};
